var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYtBgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.18 14.5035C30.9165 13.5247 30.1447 12.7529 29.1659 12.4894C27.3777 12 20.2247 12 20.2247 12C20.2247 12 13.0718 12 11.2835 12.4706C10.3235 12.7341 9.53295 13.5247 9.26942 14.5035C8.79883 16.2918 8.79883 20 8.79883 20C8.79883 20 8.79883 23.7271 9.26942 25.4965C9.53295 26.4753 10.3047 27.2471 11.2835 27.5106C13.0906 28 20.2247 28 20.2247 28C20.2247 28 27.3777 28 29.1659 27.5294C30.1447 27.2659 30.9165 26.4941 31.18 25.5153C31.6506 23.7271 31.6506 20.0188 31.6506 20.0188C31.6506 20.0188 31.6694 16.2918 31.18 14.5035Z",
    fill: "#FF2E6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9473 16.575V23.4267L23.8955 20.0008L17.9473 16.575Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYtBgWhite);
export default __webpack_public_path__ + "static/media/icon_yt_bgWhite.641bc9638d9b02e8a35cd07cb6a20479.svg";
export { ForwardRef as ReactComponent };